<template lang="html">
  <div>
    <v-row>
      <v-col v-for="idx in (isFirst ? 6 : 2)" :key="idx" :cols="6" :sm="6">
        <div class="item-product-grid p-relative">
          <div class="item-product-grid-wrap">
            <div class="item-product-grid-avatar">
              <div class="item-product-grid-image-skeleton">
                <v-skeleton-loader v-bind="attrs" type="image" />
              </div>
            </div>
            <div class="item-product-grid-content">
              <div class="item-product-grid-text">
                <v-skeleton-loader v-bind="attrs" type="list-item-three-line" class="custom-three-line" />
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  name: 'CustomSkeletonGrid',
  props: {
    isFirst: {
      default: true,
      type: Boolean
    }
  }
}
</script>
